import React, { Component } from 'react';
import LanguageStore from '../../../lang/index';

import flagDE from '../../../assets/images/flags/flag-de.png';
import flagFR from '../../../assets/images/flags/flag-fr.png';
import flagEN from '../../../assets/images/flags/flag-uk.png';
import flagIT from '../../../assets/images/flags/flag-it.png';

const flags = {
  de: { flag: flagDE, name: "Deutsch" },
  fr: { flag: flagFR, name: "Français" },
  en: { flag: flagEN, name: "English" },
  it: { flag: flagIT, name: "Italiano" },
};

type Props = {
  selectLanguage: (lang: string) => void,
};

type State = {
  open: boolean,
  selectedLang: string,
};

function simplifyLangCode(langCode) {
  if (!langCode) return 'en'; // fallback if langCode is undefined or null
  return langCode.split('-')[0];
}

export class NavbarLanguageToggler extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selectedLang: simplifyLangCode(LanguageStore.lang) || 'en'
    };
  }

  toggleDropdown = () => {
    this.setState(prevState => ({
      open: !prevState.open,
    }));
  };

  changeLanguage = (lang: string, event) => {
    event.stopPropagation();
    this.setState({ selectedLang: lang, open: false });
    LanguageStore.setLang(lang);
    this.props.onLangChanged(lang);
  };

  render() {
    const { open, selectedLang } = this.state;

    return (
      <div className="language-toggler" onClick={this.toggleDropdown}>
        <img src={(flags[selectedLang] && flags[selectedLang].flag) || flags['en'].flag} alt={(flags[selectedLang] && flags[selectedLang].name) || 'English'} className="flag-icon" />
        <div className="dropdown-icon">▼</div>
        {open && (
          <div className="dropdown-menu">
            {Object.entries(flags).map(([lang, { flag, name }]) => (
              <div key={lang} onClick={(event) => this.changeLanguage(lang, event)} className="dropdown-item">
                <img src={flag} alt={name} className="flag-icon" />
                {name}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}


export default NavbarLanguageToggler;



// WEBPACK FOOTER //
// ./src/App/Layout/Header/NavbarLanguageToggler.js